import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({
  volume_ml: z.number().int().positive().optional(),
  reeds_count: z.number().int().positive().optional(),
  duration_weeks: z.number().int().positive().optional(),
});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "diffusers", slug: "diffusers", name: "Diffusers",
    tagline: "Ambient scent for any room", status: "launched",
  },
  attributeSchema: schema,
  search: { columns: ["name","family","notes"], attributes: [] },
  facets: [
    { key: "family", label: "Family", type: "enum", source: "column",
      options: ["Floral","Oriental","Woody","Amber","Green","Chypre"] },
    { key: "volume_ml", label: "Volume (ml)", type: "range", source: "attribute",
      min: 50, max: 500, step: 10, unit: "ml" },
    { key: "duration_weeks", label: "Duration (wks)", type: "range", source: "attribute",
      min: 2, max: 24, step: 1, unit: "wk" },
    { key: "price", label: "Price (₹)", type: "range", source: "column",
      min: 20, max: 300, step: 5, unit: "₹" },
  ],
  pdpPanels: [
    { key: "product", label: "Product details", attributes: ["volume_ml","reeds_count","duration_weeks"] },
  ],
  seo: {
    titleTemplate: "{name} · CB16 Reed Diffuser",
    descriptionTemplate: "{name} — reed diffuser for continuous ambient fragrance.",
    routePrefix: "diffusers",
  },
  adminForm: [
    { key: "volume_ml", label: "Volume (ml)", kind: "number" },
    { key: "reeds_count", label: "Reeds included", kind: "number" },
    { key: "duration_weeks", label: "Duration (wks)", kind: "number" },
  ],
};
